import { useOrganizationStore } from 'store/modules';

export default function (to, from, next) {
    const organizationStore = useOrganizationStore();
    let featureFlag = to.matched.find((record) => record.meta.featureFlag);

    if (
        typeof featureFlag !== 'undefined' &&
        !organizationStore.featureFlags[featureFlag.meta.featureFlag]
    ) {
        next('/');
    } else {
        next();
    }
}
